import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getActiveSessions(params) {
  return request({
    url: '/training-mode',
    method: 'get',
    data: params,
  });
}

export function startTrainingSession(data) {
  return request({
    url: '/training-mode',
    method: 'post',
    data: data,
  });
}

export function stopTrainingSession(data) {
  return request({
    url: '/training-mode',
    method: 'delete',
    data: data,
  });
}

export function getZoneSupportedEvents(data) {
  return request({
    url: '/training-mode/supported-events',
    method: 'get',
    data,
  });
}

export function getSupportedFilterFields(eventName) {
  return request({
    url: '/training-mode/supported-filter-fields',
    method: 'get',
    data: {
      chickenEventName: eventName,
    },
  });
}

export function getTrainingRecordings(params) {
  return request({
    url: `/records/list`,
    method: 'get',
    data: {
      ...buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
      type: 'VISION',
    },
  });
}

export function getRecord(recordUuid, params) {
  return request({
    url: `/records/${recordUuid}`,
    method: 'get',
    data: params,
  });
}

export function getRecordingLink(uuid) {
  return request({
    url: `/records/link/${uuid}`,
    method: 'get',
    withCredentials: true,
  });
}

export function getDownloadLink(uuid) {
  return request({
    url: `/records/download/${uuid}`,
    method: 'get',
  });
}

export function downloadRecording(url, signal, onProgress) {
  return request({
    url: url,
    method: 'get',
    responseType: 'blob',
    headers: {
      Auth: 'delete',
    },
    signal,
    onProgress,
  });
}

export function deleteRecording(uuid) {
  return request({
    url: `/records/${uuid}`,
    method: 'delete',
  });
}

export function getChickenEvents() {
  return request({
    url: '/dictionaries/chickenEventName',
    method: 'get',
  });
}

export function getPnPZones(params) {
  return request({
    url: '/pnp/zones/with-streams',
    method: 'get',
    data: params,
  });
}

export function updateProcessed(recordUuid, isProcessed) {
  return request({
    url: `/records/${recordUuid}/processed`,
    method: 'put',
    data: { isProcessed },
  });
}

export function getAttachment(attachmentUuid) {
  return request({
    url: `/records/attachment/${attachmentUuid}`,
    method: 'get',
  });
}

export function getComments(recordUuid) {
  return request({
    url: `/records/comments/${recordUuid}`,
    method: 'get',
  });
}

export function addComment(recordUuid, comment) {
  return request({
    url: `/records/comments/${recordUuid}`,
    method: 'post',
    data: { commentValue: comment },
  });
}

export function deleteComment(commentUuid) {
  return request({
    url: `/records/comments/${commentUuid}`,
    method: 'delete',
  });
}
